import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsApp.css';

const WhatsApp = () => {
  // Replace with your actual WhatsApp number
  const phoneNumber = "918047682166"; 
  const message = "Hi Annai Insulation, I'm interested in your services. Can we discuss?";
  
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a 
      href={whatsappLink} 
      className="whatsapp-float" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="whatsapp-icon" />
      <span className="tooltip-text">Chat with us</span>
    </a>
  );
};

export default WhatsApp;